import React from "react";
import T from "prop-types";

const withPolling = WrappedComponent => {
  class WithPolling extends React.Component {
    componentDidMount() {
      const { refresh, refreshRate = 30000 } = this.props;
      if (refresh) {
        this.intervalId = window.setInterval(refresh.bind(this), refreshRate);
      }
    }

    componentWillUnmount() {
      clearInterval(this.intervalId);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  WithPolling.propTypes = {
    refresh: T.func,
    refreshRate: T.number
  };

  return WithPolling;
};

export default withPolling;



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/withPolling.jsx